exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "aside a{cursor:pointer}#main{padding-top:48px}@media (min-width:768px){#main{padding-top:64px}}a{cursor:pointer}.fullscreen-toggle{position:absolute;right:8px;top:6px;padding:5px;z-index:15}@media (min-width:768px){.fullscreen-toggle{right:10px;top:10px}}", ""]);

// exports
